import useIsMobile from '@/hooks/useIsMobile';
import { Product, ProductVariant } from '@/models/Product';
import { ProductListTypeEnum } from '@/utils/analytics/types';
import Paragraph, { VARIANT as PARAGRAPH_VARIANT } from '../Paragraph';
import HyperLocalAddToCart from './HyperLocalAddToCart';
import InsuranceLabel from './InsuranceLabel';
import ProductListingImage from './ProductListingImage';
import ProductPrice from './ProductPrice';
interface Props {
  productVariant: ProductVariant;
  listType?: ProductListTypeEnum;
  position?: number;
  componentName?: string;
  componentId?: string | number;
  isWishlist?: boolean;
  product?: Product;
}
const ProductVariantCard = ({
  productVariant,
  listType,
  position,
  componentName,
  componentId,
  isWishlist,
  product
}: Props) => {
  const {
    isMobile
  } = useIsMobile();
  const {
    name: productName,
    image_url: productImage
  } = productVariant.product as Product;
  const hasInsurance = productVariant.insuranceData ? productVariant.insuranceData.hasInsurance : false;
  const imageAndName = <div className="flex items-center shrink-0 min-w-0">
      <div className="relative flex flex-col items-center">
        <ProductListingImage imageUrl={productImage} productName={productName} imageClassName="h-20 w-20" fallbackClassName="h-8 w-8" outOfStockImageClassName="h-20 w-20" />
        {hasInsurance ? <div className="absolute" style={{
        top: 'calc(100% - 1px)'
      }}>
            <InsuranceLabel />
          </div> : null}
      </div>
      <Paragraph variant={PARAGRAPH_VARIANT.BIG} className="ml-3 font-medium text-[#33393D] shrink-0 grow-0">
        {productVariant.attribute_value[0].name}
      </Paragraph>
    </div>;
  const priceBlock = <div className={isMobile ? 'w-full min-w-0' : 'flex flex-1 flex-col justify-center min-w-0 py-1 self-center'}>
      <ProductPrice variant={productVariant} showDiscountPercentage />
    </div>;
  const addToCart = <HyperLocalAddToCart productVariant={productVariant} listType={listType} index={position} isDrawerVisible={true} fullWidthCta={isMobile} componentName={componentName} componentId={componentId} isWishlist={isWishlist} product={product} />;
  return <section className={`bg-white border-neutral-10 rounded shadow-[0_4px_4px_rgba(0,0,0,0.05)] w-full ${hasInsurance ? 'pb-[27px]' : ''} ${isMobile ? 'flex flex-col gap-2.5 p-3' : 'flex items-start gap-2 pr-3'}`} data-sentry-component="ProductVariantCard" data-sentry-source-file="ProductVariantCard.tsx">
      {isMobile ? <>
          {imageAndName}
          {priceBlock}
          <div className="w-full">{addToCart}</div>
        </> : <>
          {imageAndName}
          {priceBlock}
          {addToCart}
        </>}
    </section>;
};
export default ProductVariantCard;